/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const paymentMethodEventSchema = z.enum(['updated', 'primary-changed', 'deleted'])

export type PaymentMethodEventSchema = z.infer<typeof paymentMethodEventSchema>
